import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Cts from "./views/Components.vue";

import HomePage from "./views/HomePage.vue";
import Landing from "./views/Landing.vue";
import Luodi from './views/components/Luodi.vue';

import DocQuery from "./views/DocQuery.vue";
import DocQueryList from "./views/DocQueryList.vue";
import DocQueryListdetail from "./views/DocQueryListdetail.vue";

import PersBlog from "./views/PersBlog.vue";
import BlogDetail from "./views/BlogDetail.vue";
import AboutUs from "./views/AboutUs.vue";

import PersonalDataList from "./views/PersonalDataList.vue"
import PersonalDataEdit from "./views/PersonalDataEdit.vue"
import PersonalDataEdit1 from "./views/PersonalDataEdit1.vue"

import PersonalCollectList from "./views/PersonalCollectList.vue";

import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "components",
      components: {
        header: AppHeader,
        default: HomePage
        // ,footer: AppFooter
      }
    },
{
  path: '/BlogDetail/:id',  // 博客详情页路径
  name: 'BlogDetail',
  components: { 
    header: AppHeader,  // 导航栏组件
    default: BlogDetail,  // 博客详情组件
   },
  props: { default: true }  // 启用 props 传递
},
    {
      path: "/cs",
      name: "Cts",
      components: {
        header: AppHeader,
        default: Cts,
        footer: AppFooter
      }
    },
	 {
      path: '/luodi',
      name: 'luodi',
      components: {
        header: AppHeader,
        default: Luodi
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/DocQuery",
      name: "DocQuery",
      components: {
        header: AppHeader,
        default: DocQuery// ,
        // footer: AppFooter
      }
    },
    {
      path: "/DocQueryList",
      name: "DocQueryList",
      components: {
        header: AppHeader,
        default: DocQueryList
        // ,footer: AppFooter
      }
    },
    {
      path: "/DocQueryListdetail",
      name: "DocQueryListdetail",
      components: {
        header: AppHeader,
        default: DocQueryListdetail
        // ,footer: AppFooter
      }
    },
    {
      path: "/PersBlog",
      name: "PersBlog",
      components: {
        header: AppHeader,
        default: PersBlog
        // ,footer: AppFooter
      }
    },
    {
      path: "/AboutUs",
      name: "AboutUs",
      components: {
        header: AppHeader,
        default: AboutUs
        // ,footer: AppFooter
      }
    },
    {
      path: "/PersonalDataList",
      name: "PersonalDataList",
      components: {
        header: AppHeader,
        default: PersonalDataList
        // ,footer: AppFooter
      }
    },
    {
      path: "/PersonalDataEdit",
      name: "PersonalDataEdit",
      components: {
        header: AppHeader,
        default: PersonalDataEdit
        // ,footer: AppFooter
      }
    },
    {
      path: "/PersonalDataEdit1",
      name: "PersonalDataEdit1",
      components: {
        header: AppHeader,
        default: PersonalDataEdit1
        // ,footer: AppFooter
      }
    },
    {
      path: "/PersonalCollectList",
      name: "PersonalCollectList",
      components: {
        header: AppHeader,
        default: PersonalCollectList
        // ,footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login
        // ,footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register
        // ,footer: AppFooter
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
     if (savedPosition) {
       return savedPosition; // 当有保存的位置时，恢复到保存的位置
     } else {
       return { x: 0, y: 0 }; // 否则滚动到顶部
     }
   },
});
